// A date input reports its value on every keystroke, so while someone types a
// year the page sees "0002-10-01", "0020-10-01", then (one digit too many)
// "20202-10-01". Only a finished, sensible day may be sent to the server —
// anything else is still being typed.
export const DAY_MIN = "2000-01-01";
export const DAY_MAX = "2099-12-31";

export const isCompleteDay = (value) =>
  typeof value === "string" &&
  /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value) &&
  value >= DAY_MIN &&
  value <= DAY_MAX;
